<template>
  <div>
    <px-view-header title="Solicitações" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <div class="mt-5">
      <listagem-requisicao-header :on-click-refresh="onClickRefresh"
                                  :on-change-filter="onChangeFilter"
                                  @change="onChangeFilter"/>
      <lista-requisicao :requisicoes="requisicoes" :loading="loading"
                        :on-change-options="onChangeOptions"
                        :options-list="optionsList"
                        @update="onClickRefresh"
                        @remove="onRemove"
                        @cancelar="onCancelar"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import paginationMixin from '@/mixins/pagination-mixin';
import ListagemRequisicaoHeader from '@/modules/requisicao/listagem/ListagemRequisicaoHeader.vue';
import ListaRequisicao from '@/modules/requisicao/listagem/ListaRequisicao.vue';
import RequisicaoService from '../requisicoes-service';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      requisicoes: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: '',
        sort: 'createdIn',
        sortDesc: true,
      },
      loading: false,
      breadcrumbs: [
        { text: 'Gestão de compras' },
        { text: 'Solicitações' },
      ],
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemRequisicao', ['stringFilter']),
  },
  methods: {
    onChangeFilter() {
      this.listOptions.filter = this.stringFilter;
      this.resetPage();
      this.getRequisicoes();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getRequisicoes();
    },
    onClickRefresh() {
      this.getRequisicoes();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    onRemove(id) {
      this.loading = true;
      RequisicaoService.excluirRascunho(id)
        .then(() => {
          this.$toast('Rascunho excluido com sucesso', { color: 'success' });
          this.getRequisicoes();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getRequisicoes() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return RequisicaoService.getRequisicoes({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.requisicoes = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onCancelar(id) {
      this.loading = true;
      RequisicaoService.cancelar(id)
        .then(() => {
          this.$toast('Requisicao cancelada com sucesso', { color: 'success' });
          this.getRequisicoes();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  components: {
    ListagemRequisicaoHeader,
    ListaRequisicao,
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
    this.listOptions.filter = this.stringFilter;
  },
};
</script>
